<script lang="ts">
  import type { PopupSettings } from '@skeletonlabs/skeleton';

  let classname = '';
  export { classname as class };
  export let config: PopupSettings;
</script>

<div class={`alii-tooltip card max-w-[230px] border bg-surface-500 font-normal leading-[18px] ${classname}`} data-popup={config.target}>
  <div class="alii-tooltip-content rounded-lg px-3 py-4">
    <slot />
  </div>
</div>

<style lang="postcss">
  @import '$lib/theme/_colours.postcss';
  @import '$lib/theme/_mixins.postcss';
  .alii-tooltip {
    border-color: var(--tooltipBorder);
    @mixin shadow;
  }
  .alii-tooltip-content {
    color: var(--tooltipText);
    font-size: 12px;
  }
</style>
